import cx from 'classnames';
import React from 'react';
import { ConditionalView } from '../../utils/ConditionalView';
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import Checkbox from '../Checkbox/Checkbox';
import IconButton from '../IconButton/IconButton';
import styles from './CheckboxItem.module.scss';
import usePresenter from './CheckboxItem.presenter';
import type { CheckboxItemProps } from './CheckboxItem.types';

const CheckboxItem = React.forwardRef<HTMLInputElement, CheckboxItemProps>((props: CheckboxItemProps, ref) => {
  const {
    variantProps,
    isChecked,
    handleChange,
    required,
    otherInputProps,
    defaultChecked,
    invalid,
    labelAlignment,
    value,
    disabled,
    showRightButton,
    onRightButtonClick,
    rightButtonIcon,
    id,
  } = usePresenter(props);

  return (
    <div
      className={cx(
        styles.checkboxItem,
        props.className,
        {
          [styles.disabled]: disabled,
          [styles.hasRightButton]: showRightButton,
        },
      )}
      {...variantProps}
    >
      <Checkbox
        checked={isChecked}
        defaultChecked={defaultChecked}
        onValueChange={handleChange}
        disabled={disabled}
        invalid={invalid}
        required={required}
        labelAlignment={labelAlignment}
        ref={ref}
        value={value}
        id={id}
        {...otherInputProps}
        className={cx(styles.checkbox, otherInputProps.className)}
      >
        <WrapTextNodes className={styles.text}>
          {props.children}
        </WrapTextNodes>
      </Checkbox>
      <ConditionalView condition={showRightButton}>
        <IconButton
          className={styles.rightButton}
          onClick={onRightButtonClick}
          disabled={disabled}
          appearance="Default"
          size="Small"
          style="Secondary"
          icon={rightButtonIcon}
          type="Ghost"
          actionType="button"
        />
      </ConditionalView>
    </div>
  );
});

export default CheckboxItem; 